import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  heroArchiveBox,
  heroArrowsRightLeft,
  heroArrowUturnLeft,
  heroCheckCircle,
  heroEllipsisHorizontal,
  heroFlag,
  heroMoon,
  heroPlay,
  heroSignalSlash,
  heroSparkles,
  heroStop,
  heroTag,
  heroUserPlus,
  heroXMark,
} from '@ng-icons/heroicons/outline';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { formatRelativeTime } from '../../../../mappers/conversation.mapper';

/** Shared one-line row used by every concrete renderer: dot/icon + title + optional detail + time. */
@Component({
  selector: 'app-history-row',
  imports: [NgIcon],
  providers: [
    provideIcons({
      heroArchiveBox,
      heroArrowsRightLeft,
      heroArrowUturnLeft,
      heroCheckCircle,
      heroEllipsisHorizontal,
      heroFlag,
      heroMoon,
      heroPlay,
      heroSignalSlash,
      heroSparkles,
      heroStop,
      heroTag,
      heroUserPlus,
      heroXMark,
    }),
  ],
  template: `
    <li class="history-row" [class.history-row--backfilled]="backfilled()">
      <span class="history-row__indicator" aria-hidden="true">
        @if (icon(); as name) {
          <ng-icon [name]="name" size="13" />
        } @else {
          <span class="history-row__dot"></span>
        }
      </span>
      <div class="history-row__content">
        <span class="history-row__title">{{ title() }}</span>
        @if (detail()) {
          <span class="history-row__detail">{{ detail() }}</span>
        }
      </div>
      <time class="history-row__time" [attr.datetime]="occurredAt()">{{ relativeTime() }}</time>
    </li>
  `,
  styleUrl: './renderer-row.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HistoryRowComponent {
  readonly title = input.required<string>();
  readonly detail = input<string | null>(null);
  readonly icon = input<string | null>(null);
  readonly occurredAt = input.required<string>();
  readonly backfilled = input<boolean>(false);

  protected readonly relativeTime = computed(() => formatRelativeTime(this.occurredAt()));
}
